import { ReactComponent as Icon } from '../../assets/icons/companyIcon.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" />;
}
